import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { loadUploaderTypes } from '../../../store/directusService';

import BatchUploaderModal from './BatchUploaderModal';

const BatchUploader = ({ isOpen, onClose }) => {
    const dispatch = useDispatch();
    const [enabledContracts, setEnabledContracts] = useState([]);

    const [isBatchUploaderModalOpen, setIsBatchUploaderModalOpen] = useState(false);

    const uploaderTypes = useSelector((state) => state.entities.directusService.uploaderTypes);

    useEffect(() => {
        if (!uploaderTypes.length) dispatch(loadUploaderTypes());
    }, []);

    useEffect(() => {
        if (!uploaderTypes.length) return;
        const validContracts = uploaderTypes
            .find((el) => el.name.toLowerCase() === 'batch uploader')
            ?.contract.map((el) => el.contract_id);

        setEnabledContracts(validContracts);
    }, [uploaderTypes]);

    useEffect(() => {
        setIsBatchUploaderModalOpen(isOpen);
    }, [isOpen]);

    const onBatchUploaderModalClose = (e, reason) => {
        if (reason && reason === 'backdropClick') return;
        setIsBatchUploaderModalOpen(false);
        onClose();
    };

    const onCancel = () => {
        setIsBatchUploaderModalOpen(false);
        onClose();
    };

    return (
        <BatchUploaderModal
            contracts={enabledContracts}
            onClose={onBatchUploaderModalClose}
            isOpen={isBatchUploaderModalOpen}
            onCancel={onCancel}
        />
    );
};

export default BatchUploader;

BatchUploader.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func
};
